/* eslint-disable */
// src/layouts/machineType/data/machineTypeTableData.js

export default function machineTypeTableData({ machineTypes }) {
  return {
    columns: [{ Header: "", accessor: "Type", align: "left" }],
    rows: machineTypes.map((mt) => ({
      Type: mt.Type,
    })),
  };
}
